import { render, staticRenderFns } from "./Net.vue?vue&type=template&id=068f8f6e"
import script from "./Net.vue?vue&type=script&lang=js"
export * from "./Net.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports